/**
 * Accessibility props for a pressable that acts as a checkbox.
 *
 * react-native-web 0.21 drops false-valued `accessibilityState` entries, so an
 * unchecked box rendered no `aria-checked` at all and screen readers could not
 * announce "not checked" (same gotcha as `aria-selected`). `aria-checked` is
 * emitted explicitly for both states.
 */
export function checkboxA11y(checked: boolean, disabled = false) {
  return {
    accessibilityRole: 'checkbox' as const,
    accessibilityState: { checked, disabled },
    'aria-checked': checked,
  };
}
